import { Helmet } from 'react-helmet-async'
import React from 'react'

type HeadProps = {
  title?: string
  description?: string
  canonical?: string
  prevUrl?: string
  nextUrl?: string
}

export const Head: React.FC<HeadProps> = (props: HeadProps) => {
  return (
    <Helmet>
      <meta charSet="utf-8" />
      <meta content="width=device-width, user-scalable=no, initial-scale=1, maximum-scale=1" name="viewport" />
      <meta content="telephone=no" name="format-detection" />
      {/*// TODO: 以下の「動的にtitle,descriptionを生成する箇所」のコメントアウトについては、Reactコンポーネントの表示完了までの時間を速くする（3秒以内）対応が終わり次第、コメントアウトを削除する。[参照スレッド](https://crowdworks.slack.com/archives/C07EL45N5L7/p1729127421569529?thread_ts=1729044649.573639&cid=C07EL45N5L7)*/}
      {/*<title>{props.title || 'クラウドワークス テック（旧クラウドテック）'}</title>*/}
      {/*<meta name="description" content={*/}
      {/*  props.description || 'フリーランスで働きたい・独立して業務委託として働きたい人のための求人サイト「クラウドワークス テック」。報酬額や勤務地、職種やスキルなどあなたの希望を専属スタッフが伺い、最適なお仕事をご提案します。'*/}
      {/*} />*/}
      <link rel="canonical" href={props.canonical} />
      {props.prevUrl && <link rel="prev" href={props.prevUrl} />}
      {props.nextUrl && <link rel="next" href={props.nextUrl} />}
    </Helmet>
  )
}
